import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";
import { CustomerPricingState } from "@crescentParts/Store/Data/CustomerPricing/CustomerPricingState";

const initialState: CustomerPricingState = {
  isLoading: false,
  exportList: [],
  pagination: {
    currentPage: 1,
    page: 1,
    pageSize: 0,
    defaultPageSize: 0,
    totalItemCount: 0,
    numberOfPages: 0,
    pageSizeOptions: [],
    sortOptions: [],
    sortType: "",
    nextPageUri: "",
    prevPageUri: "",
  },
};

const reducer = {
  "Custom/LoadCustomerPricing": (
    draft: Draft<CustomerPricingState>,
    action: {},
  ) => {
    draft.isLoading = true;
  },
  "Custom/DispatchLoadCustomerPricing": (
    draft: Draft<CustomerPricingState>,
    action: { exportList: { exportList: any[]; pagination: any } },
  ) => {
    draft.isLoading = false;
    draft.exportList = action?.exportList?.exportList as any;
    draft.pagination = action?.exportList?.pagination as any;
  },
};

export default createTypedReducerWithImmer(initialState, reducer);
